// Admin PaymentsPage — aggregate payment/revenue overview.
import { useFetch } from "../../hooks/useApi.js";
import StatCard from "../../components/shared/StatCard.js";
import type { AdminSnapshot } from "@dm-lms/shared/types";

export default function PaymentsPage() {
  const { data, isLoading, error } = useFetch<AdminSnapshot>("/api/admin/snapshot");

  return (
    <div className="dm-page">
      <h1 className="text-2xl font-semibold text-dm-navy mb-6">Payments</h1>

      {isLoading && <p className="text-dm-slate text-sm">Loading payments overview…</p>}
      {error && <p className="text-red-600 text-sm">{error}</p>}

      {data && (
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-6">
          <StatCard label="Total Revenue (KES)" value={data.totalRevenueKes.toLocaleString()} />
          <StatCard label="Pending Payments" value={data.pendingPayments} />
          <StatCard label="Total Enrollments" value={data.totalEnrollments} />
        </div>
      )}

      <p className="text-dm-slate text-sm">
        A detailed payment ledger is not yet available — this overview reflects aggregate totals only.
      </p>
    </div>
  );
}
